<div class="bg-white rounded-lg shadow-sm p-6">
  <div class="flex justify-between items-center mb-6">
    <h2 class="text-2xl font-bold text-gray-900">Histórico Financeiro</h2>
  </div>

  <div *ngIf="loading" class="flex justify-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && items.length === 0" class="py-12">
    <app-empty-state
      [message]="'Nenhum registro financeiro encontrado'">
    </app-empty-state>
  </div>

  <div *ngIf="!loading && items.length > 0" class="space-y-4">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Método</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Observações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of items" class="hover:bg-gray-50">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.dataRecebimento || item.createdAt ? formatDate(item.dataRecebimento || item.createdAt) : '-' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.fornecedor?.nome || item.fornecedorNome || '-' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span class="px-2 py-1 rounded-full text-xs font-medium"
                    [ngClass]="{
                      'bg-green-100 text-green-800': item.tipo === 'pagamento',
                      'bg-blue-100 text-blue-800': item.tipo === 'assinatura',
                      'bg-gray-100 text-gray-800': !item.tipo
                    }">
                {{ item.tipo || 'Pagamento' }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.metodoPagamento || '-' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              {{ formatCurrency(item.valor) }}
            </td>
            <td class="px-6 py-4 text-sm text-gray-500">
              {{ item.observacoes || '-' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-6" *ngIf="totalPages > 1">
      <app-pagination
        [page]="page"
        [pageSize]="pageSize"
        [total]="total"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>
